export const PAGE_CHANGE = '/ui/page/change';
export const SET_LATEST_CUSTOMER = '/ui/set/latest/customer/id';
export const SET_UNSAVED_CHANGES = '/ui/set/unsaved/changes';
export const UNSET_UNSAVED_CHANGES = '/ui/unset/unsaved/changes';
